(function ($) {

	$.fn.form = function () {

		var elem = $(this),
			fields = elem.find('.js-form__field'),
			groups = elem.find('.js-form__group'),
			settings = {
				errorClass: 'is-error',
				errorMessageSelector: '.js-form__message',
				errorMessageModifierBase: 'form__error-message',
				errorMessageModifier: '',
				formGroupSelector: '.js-form__group',
				messageAttr: 'data-message',
				tabParentId: false
			};

		var init = function () {
			// Parse settings
			settings = $.extend(true, {}, settings, elem.parseSettings());

			// If there is a modifier. Split it apart and prepend the modifier base
			if (settings.errorMessageModifier.length > 0) {
				var modSplit = settings.errorMessageModifier.trim().split(' '),
					modProcessed = '';

				if (modSplit.length > 0) {
					$.each(modSplit, function (i, val) {
						modProcessed += settings.errorMessageModifierBase + '--' + val + ' ';
					});
				}

				// Set the modifier to be the processed modifier
				settings.errorMessageModifier = modProcessed.trim();
			}

			// Run validator
			validator();
		},

			validator = function () {

				// Check for .NET update method
				if (typeof (ValidatorUpdateDisplay) != 'undefined') {
					// Store the native event
					var originalMethod = ValidatorUpdateDisplay;

					// Handle the update method ourselves
					ValidatorUpdateDisplay = function (val) {
						// Find the field from the collection
						var field = fields.filter('#' + val.controltovalidate);

						// Add the error class
						if (field.length) {
							// Find its group
							var group = field.parents(settings.formGroupSelector),

								// Convert the validation control into a jquery object
								valObject = $(val);

							if (!val.isvalid) {

								// Add error class
								field.addClass(settings.errorClass);

								// Set a message if applicable
								if (group.length && valObject.length && valObject.attr(settings.messageAttr)) {
									setGroupMessage(group, valObject.attr(settings.messageAttr), val.id);
								}

								// Attempt to show parent tab
								showParentTab();
							}
							else if (group.any()) {
								clearGroupMessages(group, val.id);

								if (group.find(settings.errorMessageSelector).length === 0) {
									// Remove error class
									field.removeClass(settings.errorClass);
								}
							}
						}
						// Run the original method
						originalMethod(val);
					};
				}

			},

			// Set an error message if applicable
			setGroupMessage = function (group, message, id) {

				// Load html template
				var template = $.renderTemplate('error-message', { 'message': message, 'modifier': settings.errorMessageModifier, id: id });

				// Clear any existing messages
				clearGroupMessages(group);

				// Add the template
				group.append(template);

				// Run the global bind incase there is any js to be attached
				app.bind(group);

				// Show
				group.find(settings.errorMessageSelector).removeClass('is-hidden');

			},

			// Clean up any error messages
			clearGroupMessages = function (group, id) {

				var message = group.find(settings.errorMessageSelector + (id !== undefined ? '[data-id="' + id + '"]' : ''));

				// If there is a message, get rid
				if (message.any()) {
					message.remove();
				}

			},

			// Trigger a hashchange event if there is a parent tab set.
			// The tab module is listening for these events if it is loaded
			showParentTab = function () {

				if (settings.tabParentId) {
					window.location.hash = settings.tabParentId;
				}
			};

		init();
		return this;
	};

}($));
